import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames(
  'flex',
  'flex-row',
  'bg-info-background-color',
  'text-info-text-color',
  'items-center',
  'rounded',
  'border',
  'border-info-border-color',
  'p-2',
  'gap-2'
);

interface Props {
  children: ReactNode;
  icon?: Icon;
}

const Info = ({ children, icon }: Props) => (
  <div className={className}>
    <div className="flex justify-center align-center text-info-icon-color">
      <IconView icon={icon} size={'lg'} />
    </div>
    <div className="text-sm">{children}</div>
  </div>
);

export default Info;
